module.exports = __webpack_public_path__ + "img/wheelbg.5d35968e.png";